var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"separator-line"}),_c('section',{staticClass:"portfolio",attrs:{"id":"portfolio"}},[_c('div',{staticClass:"container"},[_c('GameProjects')],1)]),_c('Footer',{attrs:{"showArrow":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }